'use client'

import Form from 'next/form'
import Link from 'next/link'
import { useActionState, useCallback, useEffect, useState } from 'react'
import login from './login'
import { useRouter } from 'next/navigation'
import Cookies from 'js-cookie'
import { setAuthToken } from '@/src/lib/cockies'
import { useUsuario } from '../../contexts/UsuarioContext'
import { useSearchParams } from 'next/navigation'
import { trackLogin } from '@/src/lib/analytics'

export default function FormLogin() {
  const [state, formAction, isPending] = useActionState(login, null)
  const router = useRouter()
  const [visivel, setVisivel] = useState(false)
  const [lembrarLogin, setLembrarLogin] = useState(false)
  const { usuario, setUsuario, carregarUsuario } = useUsuario()
  const searchParams = useSearchParams()

  // Verifica se é primeiro acesso (vindo de NovaSenha) para mostrar mensagem de boas vindas
  const primeiroAcesso = searchParams.get('primeiro_acesso') === 'true'

  useEffect(() => {
    if (state?.status === 'Sucesso' && state.token && state.primeiro_acesso === false) {
      trackLogin(true, 'password')
      setAuthToken(state.token) // Salva o token no cookie
      carregarUsuario(state) // Força o contexto a recarregar o usuário

      // Redireciona para a página inicial, caso sejá primeiro acesso, aparece a mensagem de boas vindas na home
      if (primeiroAcesso) {
        router.push('/?boas_vindas=true')
      } else {
        router.push('/')
      }
    } else if (state?.status === 'Sucesso' && state.primeiro_acesso === true) {
      trackLogin(true, 'password')
      // Armazena token no sessionStorage (não expõe na URL)
      sessionStorage.setItem('primeiro_acesso_token', state.token)
      router.push('/NovaSenha')
    } else if (state?.status === 'Erro') {
      trackLogin(false, 'password')
    }
    if (state != null) {
      console.log('Estado da ação de login:', state)
    }
  }, [state, router])

  return (
    <Form action={formAction} className="w-full p-2">
      <div className="grid w-full gap-5 px-4">
        {/* Mensagem de erro */}
        {state?.status === 'Erro' && (
          <div>
            <div className="rounded-lg border border-red-300 bg-red-50 p-4 text-sm text-red-700">
              <div className="flex items-center gap-2">
                <i className="bi bi-exclamation-circle-fill"></i>
                <span>{state.mensagem}</span>
              </div>
            </div>
          </div>
        )}

        {/* Campo E-mail */}
        <div>
          <label htmlFor="email" className="mb-2 block text-sm font-medium text-gray-700">
            E-mail
          </label>
          <input
            id="email"
            autoFocus
            name="email"
            className="h-12 w-full rounded-full border border-gray-300 bg-white px-4 transition-all outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
            type="email"
            placeholder="Digite seu e-mail"
          />
        </div>

        {/* Campo Senha */}
        <div className="relative mb-10">
          <label htmlFor="senha" className="mb-2 block text-sm font-medium text-gray-700">
            Senha
          </label>
          <input
            id="senha"
            name="senha"
            className="h-12 w-full rounded-full border border-gray-300 bg-white px-4 pr-12 transition-all outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200"
            type={!visivel ? 'password' : 'text'}
            placeholder="Digite sua senha"
          />
          <button
            type="button"
            onClick={() => setVisivel(!visivel)}
            className={`bi absolute top-9 right-2 grid h-8 w-8 cursor-pointer items-center justify-center rounded-full transition-colors hover:bg-purple-100 ${
              visivel ? 'bi-eye' : 'bi-eye-slash'
            }`}
            aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
          />
        </div>

        {/* Checkbox Lembrar Login 
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="lembrar"
              name="lembrar"
              checked={lembrarLogin}
              onChange={(e) => setLembrarLogin(e.target.checked)}
              className="w-4 h-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500 focus:ring-2"
            />
            <label htmlFor="lembrar" className="text-sm text-gray-700 cursor-pointer select-none">
              Lembrar login
            </label>
          </div>
        */}

        {/* Link Esqueci a Senha */}
        <div className="text-center">
          <div className="text-center">
            <Link href="/NovaSenha">
              <span className="cursor-pointer text-sm text-gray-600 transition-colors hover:text-purple-700">
                Esqueci minha senha
              </span>
            </Link>
          </div>
        </div>

        {/* Botão Entrar */}
        <button
          type="submit"
          disabled={isPending}
          className={`h-12 w-full cursor-pointer rounded-full text-lg font-medium text-white shadow-md transition-all hover:bg-pink-600 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none ${isPending ? 'bg-purple-500' : 'bg-pink-500'}`}
        >
          {isPending ? (
            <span className="flex items-center justify-center gap-2">
              <svg
                className="h-5 w-5 animate-spin text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Entrando...
            </span>
          ) : (
            'Entrar'
          )}
        </button>

        {/* Link Não possuo cadastro *
        <div className="text-center">
          <Link href="/Registrar">
            <span className="cursor-pointer text-sm text-gray-600 transition-colors hover:text-purple-700">
              Não possuo cadastro
            </span>
          </Link>
        </div>
        */}
      </div>
    </Form>
  )
}
